export enum SUPPORTED_LANGS {
  EN = 'en',
  HU = 'hu',
}
